import React, { useState, useEffect } from "react";
import "./Navigation.css";

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("");

  const sections = [
    { id: "gallery", name: "Gallery", icon: "🖼️" },
    { id: "quotes", name: "Quotes", icon: "💭" },
    { id: "timeline", name: "Timeline", icon: "📅" },
    { id: "facts", name: "Fun Facts", icon: "🌟" },
    { id: "why-ryujin", name: "Why Ryujin", icon: "💖" },
    { id: "videos", name: "Videos", icon: "🎬" },
    { id: "guestbook", name: "Guestbook", icon: "💬" },
    { id: "newsletter", name: "Newsletter", icon: "📧" }
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 100;
      
      for (const section of sections) {
        const element = document.getElementById(section.id);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section.id);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <>
      <nav className={`navigation ${isMenuOpen ? 'open' : ''}`}>
        <div className="nav-header">
          <button className="nav-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <span className="hamburger"></span>
            <span className="hamburger"></span>
            <span className="hamburger"></span>
          </button>
          <div className="nav-logo" onClick={scrollToTop}>
            <span className="logo-icon">🌟</span>
            <span className="logo-text">Ryujin</span>
          </div>
        </div>

        <div className="nav-menu">
          <div className="nav-section">
            <h3 className="nav-section-title">Sections</h3>
            {sections.map((section) => (
              <button
                key={section.id}
                className={`nav-item ${activeSection === section.id ? 'active' : ''}`}
                onClick={() => scrollToSection(section.id)}
              >
                <span className="nav-icon">{section.icon}</span>
                <span className="nav-text">{section.name}</span>
              </button>
            ))}
          </div>

          <div className="nav-section">
            <h3 className="nav-section-title">Quick Actions</h3>
            <button className="nav-item" onClick={() => scrollToSection('gallery')}>
              <span className="nav-icon">🎲</span>
              <span className="nav-text">Random Photo</span>
            </button>
            <button className="nav-item" onClick={() => scrollToSection('quotes')}>
              <span className="nav-icon">🎲</span>
              <span className="nav-text">Random Quote</span>
            </button>
          </div>

          <div className="nav-footer">
            <p className="nav-footer-text">Made with 💕 for MIDZYs</p>
          </div>
        </div>
      </nav>

      {/* Overlay for mobile */}
      {isMenuOpen && (
        <div className="nav-overlay" onClick={() => setIsMenuOpen(false)}></div>
      )}
    </>
  );
};

export default Navigation;
